var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63901 1.74893C4.92773 1.61016 5.27044 1.64918 5.52058 1.84929L7.05505 3.07686L8.4047 1.87717C8.72044 1.59652 9.19623 1.59652 9.51197 1.87717L10.8333 3.05172L12.1547 1.87717C12.4704 1.59652 12.9462 1.59652 13.262 1.87717L14.6116 3.07686L16.1461 1.84929C16.3962 1.64918 16.7389 1.61016 17.0277 1.74893C17.3164 1.88769 17.5 2.17968 17.5 2.50001V16.25C17.5 17.4006 16.5673 18.3333 15.4167 18.3333H5C3.61929 18.3333 2.5 17.2141 2.5 15.8333V15C2.5 14.5398 2.8731 14.1667 3.33333 14.1667H4.16667V2.50001C4.16667 2.17968 4.35029 1.88769 4.63901 1.74893ZM4.16667 15.8333C4.16667 16.2936 4.53976 16.6667 5 16.6667H13.375C13.3477 16.5321 13.3333 16.3927 13.3333 16.25V15.8333H4.16667ZM5.83333 14.1667V4.23387L6.56275 4.8174C6.8798 5.07104 7.3335 5.05927 7.63697 4.78952L8.95833 3.61498L10.2797 4.78952C10.5954 5.07018 11.0712 5.07018 11.387 4.78952L12.7083 3.61498L14.0297 4.78952C14.3332 5.05927 14.7869 5.07104 15.1039 4.8174L15.8333 4.23387V16.25C15.8333 16.4801 15.6468 16.6667 15.4167 16.6667C15.1865 16.6667 15 16.4801 15 16.25V15C15 14.5398 14.6269 14.1667 14.1667 14.1667H5.83333Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 12.0833C7.08333 11.6231 7.45643 11.25 7.91667 11.25H13.75C14.2102 11.25 14.5833 11.6231 14.5833 12.0833C14.5833 12.5436 14.2102 12.9167 13.75 12.9167H7.91667C7.45643 12.9167 7.08333 12.5436 7.08333 12.0833Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 9.58334C7.08333 9.1231 7.45643 8.75 7.91667 8.75H13.75C14.2102 8.75 14.5833 9.1231 14.5833 9.58334C14.5833 10.0436 14.2102 10.4167 13.75 10.4167H7.91667C7.45643 10.4167 7.08333 10.0436 7.08333 9.58334Z",
    fill: "#4F5E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 7.08334C7.08333 6.6231 7.45643 6.25 7.91667 6.25H10.8333C11.2936 6.25 11.6667 6.6231 11.6667 7.08334C11.6667 7.54358 11.2936 7.91667 10.8333 7.91667H7.91667C7.45643 7.91667 7.08333 7.54358 7.08333 7.08334Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleInvoice);
export default __webpack_public_path__ + "static/media/sale-invoice.0af3fe51ad7301c7c2a9db8b0b152b6f.svg";
export { ForwardRef as ReactComponent };